import { BaseModel } from "./base.model";

export class MemberAgreementModel extends BaseModel {
    memberName: string | null;
    cardId: number | null;
    cardNo: string | null;
    no_owner_verified: number | null;
    name: string | null;
    ratioOwner: number | null;
    ratioWorker: number | null;
    ownerName: string | null;
    ownerCardNo: string | null;
    office_id: number | string;
}
